import Swiper, { Autoplay } from "swiper";

export default class HeroSlider {
    constructor() {
        this.slider = document.querySelector('.js-hero-slider');
        
        if(this.slider){
            this.init();
        }
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Autoplay],
            loop: true,
            spaceBetween: 8,
            slidesPerView: 1,
            autoplay: { enabled:false },
            breakpoints: {
                1024: {
                    autoplay: {
                        enabled: true,
                        delay: 5000
                    }
                }
            }
        });

    }
}
